import React from "react";
import { string, number, object, bool, oneOfType } from "prop-types";
import { isScreenReaderCompatible } from "utils/helperFunctions";
import { adjustedTimeExcludedTests } from "./helpers";
import AssessmentInfoBox from "./AssessmentInfoBox";

const TestBatteryInfoCards = ({
  testBatterySubTests,
  job,
  testBatteryId,
  jobDetailId,
  placedAtJobSettings,
  timeFactor,
  testMakerTests,
  fromScheduleExistingCandidates,
  assessmentSettings,
  filterBy,
}) => {
  const testBatteryInfo = testBatterySubTests.valueSeq().map((test) => {
    const testId = test.get("testId");
    const subTestId = test.get("subTestId");

    let isTimedTest = false;
    let useAdjustedTimeFactor = true;

    if (job && !fromScheduleExistingCandidates) {
      const batteryTestData = placedAtJobSettings
        ? job.getIn(["batteries", "data", String(testBatteryId), testId])
        : job.getIn([
            jobDetailId,
            "batteries",
            "data",
            String(testBatteryId),
            testId,
          ]);

      const batteryTest =
        batteryTestData && typeof batteryTestData.first === "function"
          ? batteryTestData.first()
          : null;

      isTimedTest =
        batteryTest && typeof batteryTest.get === "function"
          ? batteryTest.get("timedTest")
          : false;
    } else {
      isTimedTest = test.get("timedTest");
    }

    let isTMTypingTest = false;
    if (testId.includes("TM") && testMakerTests && testMakerTests.size !== 0) {
      isTMTypingTest = testMakerTests.getIn([testId.substr(2), "isTyping"]);
    }

    // Exclude CAST, TT, MRAB, and TM Typing Test from the Adjusted Time functionality
    if (
      !isTimedTest ||
      adjustedTimeExcludedTests.includes(testId) ||
      isTMTypingTest
    ) {
      useAdjustedTimeFactor = false;

      if (filterBy === "adjustedTime") {
        return;
      }
    }

    if (
      filterBy === "screenReaderCompatibility" &&
      !isScreenReaderCompatible(Number(testId), subTestId)
    ) {
      return;
    }

    return (
      <AssessmentInfoBox
        key={testId}
        test={test}
        assessmentSettings={assessmentSettings}
        timeFactor={useAdjustedTimeFactor ? timeFactor : 1}
      />
    );
  });

  return testBatteryInfo;
};

TestBatteryInfoCards.propTypes = {
  testBatterySubTests: object,
  job: object,
  testBatteryId: number,
  jobDetailId: string,
  placedAtJobSettings: bool,
  timeFactor: oneOfType([number, string]),
  testMakerTests: object,
  fromScheduleExistingCandidates: bool,
  assessmentSettings: object,
  filterBy: string,
};

export default TestBatteryInfoCards;
